export enum NodeTypesEnum {
  AgentNode = "AgentNode",
}
